"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_text_mask_1 = __importDefault(require("react-text-mask"));
const classnames_1 = __importDefault(require("classnames"));
require("@hotmart/cosmos/dist/form/form.css");
require("@hotmart/cosmos/dist/form/input-default.css");
require("@hotmart/cosmos/dist/form/input-validate.css");
const InputMask = ({ className, hasError, size, ...rest }) => {
    const classes = (0, classnames_1.default)('hot-form__input', { 'is-invalid': hasError, [`hot-form__input--${size}`]: size }, className);
    return (0, jsx_runtime_1.jsx)(react_text_mask_1.default, { className: classes, ...rest });
};
exports.default = InputMask;
